
import { defineComponent, reactive, watch, ref, onMounted } from 'vue'
import about from '@/components/about.vue'
interface emitColor {
  color: string
  originalColor: string
}
export default defineComponent({
  props: {
    searchText: String,
  },
  setup(props, context) {
    const state = reactive({
      text: '',
      colorPicker: '',
      input_state: false,
      imgs: {
        dice: require('@/assets/img/dice.svg'),
        about: require('@/assets/img/about.svg'),
        showAbout: true,
      },
    })
    // 监听输入变化
    watch(
      () => state.text,
      (val, oval): void => {
        let hexRegex: RegExp = /^[0-9a-fA-F]{6}$/i
        let originalColor: string = val
        if (val.length == 3 || val.length == 6) {
          val = val.length == 3 ? val + val : val
          if (hexRegex.test(val)) {
            state.input_state = false
            state.colorPicker = val
            context.emit('emitColor', <emitColor>{
              color: val,
              originalColor,
            })
          }
        } else {
          state.input_state = true
          state.colorPicker = ''
          context.emit('emitColor', null)
        }
      }
    )
    watch(
      () => props.searchText as string,
      (val, oval): void => {
        state.text = val
      }
    )
    // 事件
    const randomAllColors: () => void = () => {
      context.emit('randomAllColors')
    }
    const colorPickerInput = (e: Event) => {
      let color: string = ((<HTMLInputElement>e.target)
        .value as string).replace('#', '')
      state.colorPicker = state.text = color
    }

    return { state, colorPickerInput, randomAllColors }
  },
  components: {
    about,
  },
})
